import { render, staticRenderFns } from "./FiltersSidebar.vue?vue&type=template&id=50344ffd&scoped=true&"
import script from "./FiltersSidebar.vue?vue&type=script&lang=js&"
export * from "./FiltersSidebar.vue?vue&type=script&lang=js&"
import style0 from "./FiltersSidebar.vue?vue&type=style&index=0&id=50344ffd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50344ffd",
  null
  
)

export default component.exports